<template>
  <div>
    <v-row class="mb-3">
      <v-col cols="12" class="d-flex align-center">
        <h1 class="text-h4">Lista de Avaliações da Play Store</h1>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>

    <!-- Filters -->
    <v-expansion-panels class="mb-4" :model-value="[0]">
      <v-expansion-panel title="Filtros">
        <template v-slot:text>
          <v-row>
            <v-col cols="12" md="2">
              <label style="font-size: 12px">Data início:</label>
              <v-text-field v-model="dtinicio" type="date" dense hide-details />
            </v-col>
            <v-col cols="12" md="2">
              <label style="font-size: 12px">Data fim:</label>
              <v-text-field v-model="dtfinal" type="date" dense hide-details />
            </v-col>
            <v-col cols="12" md="5">
              <label style="font-size: 12px">Pesquisar (nome ou mensagem):</label>
              <v-text-field v-model="pesquisar" dense hide-details clearable />
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" class="d-flex ga-2">
              <v-btn color="primary" @click="buscar" :loading="loading">
                <v-icon start>mdi-magnify</v-icon>
                Pesquisar
              </v-btn>
              <v-btn @click="limpar" :loading="loading">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn color="secondary" @click="abrirCadastro">
                <v-icon start>mdi-plus</v-icon>
                Cadastrar
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Create / Edit Dialog -->
    <v-dialog v-model="dialogForm" max-width="600" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          {{ editandoId ? 'Editar Avaliação' : 'Cadastrar Avaliação' }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-form ref="formRef">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.nome" label="Nome *" :rules="[rules.required]" variant="outlined" dense
                  hide-details="auto" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.data_avaliacao" label="Data da avaliação *" type="date"
                  :rules="[rules.required]" variant="outlined" dense hide-details="auto" />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="form.mensagem" label="Mensagem *" :rules="[rules.required]" variant="outlined"
                  rows="4" hide-details="auto" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn variant="text" @click="fecharDialogForm" :disabled="apiCrud.loading.value">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="salvar" :loading="apiCrud.loading.value">
            {{ editandoId ? 'Salvar' : 'Cadastrar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="dialogDelete" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">Confirmar exclusão</v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          Tem certeza que deseja excluir esta avaliação? Esta ação não pode ser desfeita.
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn variant="text" @click="dialogDelete = false" :disabled="apiCrud.loading.value">
            Cancelar
          </v-btn>
          <v-btn color="red" @click="confirmarDelete" :loading="apiCrud.loading.value">
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Table -->
    <v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="itemsPerPage"
      class="elevation-1" disable-pagination>
      <template #item.data_avaliacao="{ item }">
        {{ item.data_avaliacao }}
      </template>

      <template #item.mensagem="{ item }">
        <div style="
            max-width: 420px;
            white-space: pre-wrap;
            word-break: break-word;
            overflow-wrap: anywhere;
          ">
          {{ item.mensagem }}
        </div>
      </template>

      <template #item.acoes="{ item }">
        <v-btn icon size="small" class="mr-1" @click="abrirEdicao(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon size="small" color="red" @click="abrirDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template #bottom>
        <div class="d-flex justify-space-between align-center px-4 py-2">
          <div class="d-flex align-center ga-2">
            <span class="text-caption text-secondary">
              Total: {{ total }} registro{{ total !== 1 ? 's' : '' }}
            </span>
            <v-select v-model="itemsPerPage" :items="[10, 25, 50, 100]" label="Itens por página" variant="outlined"
              dense hide-details style="width: 140px" @update:model-value="onPerPageChange" />
          </div>
          <v-pagination v-if="totalPages > 1" :model-value="page" :length="totalPages" :total-visible="5" rounded
            class="my-2" @update:model-value="onPageChange" />
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useApi } from '@/utils/axios'
import { AVALIACAO_PLAY_STORE_ROTAS } from '@/utils/apiRoutes'
import { formatToDateBR } from '@/utils/date'
import { useNotificationStore } from '@/stores/notification'

const notificationStore = useNotificationStore()

const apiList = useApi(AVALIACAO_PLAY_STORE_ROTAS.LISTAR)
const apiCrud = useApi(AVALIACAO_PLAY_STORE_ROTAS.LISTAR)

// --- Filter state ---
const dtinicio = ref('')
const dtfinal = ref('')
const pesquisar = ref('')

// --- Pagination state ---
const page = ref(1)
const itemsPerPage = ref(10)
const total = ref(0)
const items = ref([])
const loading = apiList.loading

const totalPages = computed(() => Math.max(1, Math.ceil((total.value || 0) / itemsPerPage.value)))

// --- Dialog state ---
const dialogForm = ref(false)
const dialogDelete = ref(false)
const editandoId = ref(null)
const deletandoId = ref(null)
const formRef = ref(null)

const formVazio = () => ({
  nome: '',
  data_avaliacao: '',
  mensagem: '',
})
const form = ref(formVazio())

const rules = {
  required: (v) => (v !== null && v !== undefined && v !== '') || 'Campo obrigatório',
}

const headers = [
  { title: 'Nome', value: 'nome', sortable: true },
  { title: 'Data da Avaliação', value: 'data_avaliacao', sortable: true },
  { title: 'Mensagem', value: 'mensagem', sortable: false },
  { title: 'Criado em', value: 'created_at', sortable: true },
  { title: 'Ações', value: 'acoes', sortable: false },
]

// --- Data fetch ---
async function buscar() {
  const params = {
    dtinicio: dtinicio.value || undefined,
    dtfinal: dtfinal.value || undefined,
    pesquisar: pesquisar.value || undefined,
    page: page.value,
    perPage: itemsPerPage.value,
  }

  try {
    const res = await apiList.fetch({ params })
    const raw = res?.data || []
    items.value = raw.map((r) => ({
      id: r.id,
      nome: r.nome ?? '',
      data_avaliacao: r.data_avaliacao ? formatToDateBR(r.data_avaliacao) : '',
      mensagem: r.mensagem ?? '',
      created_at: r.created_at ? formatToDateBR(r.created_at) : '',
      _raw: r,
    }))
    total.value = res?.meta?.total ?? res?.total ?? items.value.length
  } catch {
    // error handled by useApi
  }
}

function limpar() {
  dtinicio.value = ''
  dtfinal.value = ''
  pesquisar.value = ''
  page.value = 1
  itemsPerPage.value = 10
  items.value = []
  total.value = 0
}

function onPageChange(newPage) {
  page.value = newPage
  buscar()
}

function onPerPageChange() {
  page.value = 1
  buscar()
}

// --- CRUD ---
function abrirCadastro() {
  editandoId.value = null
  form.value = formVazio()
  dialogForm.value = true
}

function abrirEdicao(item) {
  editandoId.value = item.id
  const r = item._raw || {}

  let date = ''

  if (r.data_avaliacao) {
    date = r.data_avaliacao.split('T')[0]
  }

  form.value = {
    nome: r.nome ?? '',
    data_avaliacao: date,
    mensagem: r.mensagem ?? '',
  }
  dialogForm.value = true
}

function fecharDialogForm() {
  dialogForm.value = false
  formRef.value?.reset()
}

async function salvar() {
  const { valid } = await formRef.value.validate()
  if (!valid) return

  const payload = {
    nome: form.value.nome,
    data_avaliacao: form.value.data_avaliacao,
    mensagem: form.value.mensagem,
  }

  try {
    if (editandoId.value) {
      await apiCrud.put(payload, editandoId.value)
      notificationStore.showNotification('Avaliação atualizada com sucesso', 'success')
    } else {
      await apiCrud.post(payload)
      notificationStore.showNotification('Avaliação cadastrada com sucesso', 'success')
    }
    fecharDialogForm()
    buscar()
  } catch (e) {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      (editandoId.value ? 'Erro ao atualizar avaliação' : 'Erro ao cadastrar avaliação')
    notificationStore.showNotification(msg, 'error')
  }
}

function abrirDelete(item) {
  deletandoId.value = item.id
  dialogDelete.value = true
}

async function confirmarDelete() {
  try {
    await apiCrud.del(deletandoId.value)
    notificationStore.showNotification('Avaliação excluída com sucesso', 'success')
    dialogDelete.value = false
    deletandoId.value = null
    buscar()
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.response?.data?.error || 'Erro ao excluir avaliação'
    notificationStore.showNotification(msg, 'error')
  }
}
</script>
